import * as React from 'react';
import { identity } from 'lodash';
export var MapStateDefault = {
  entityFilter: identity,
  entityTypeNames: [],
  entitySubTypeNames: []
};
export var MapStateContext = React.createContext([MapStateDefault, function () {}]);
export var MapStateProvider = function MapStateProvider(props) {
  return React.createElement(MapStateContext.Provider, {
    value: React.useState(props.value || MapStateDefault)
  }, props.children);
};